import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiagnosisComponent } from './component/diagnosis/diagnosis.component';
import { DiagnosisWebSocketService } from './service/diagnosis-web-socket.service';
import { VehicleSelectComponent } from './component/vehicle-select/vehicle-select.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { VehicleService } from './service/vehicle.service';
import { DiagnosisService } from './service/diagnosis.service';
import { MaterializeModule } from 'angular2-materialize';
import { EquipmentDiagnosisComponent } from './component/equipment-diagnosis/equipment-diagnosis.component';
import { GpsDiagnosisComponent } from './component/gps-diagnosis/gps-diagnosis.component';
import { GprsDiagnosisComponent } from './component/gprs-diagnosis/gprs-diagnosis.component';
import { CoordinateDiagnosisComponent } from './component/coordinate-diagnosis/coordinate-diagnosis.component';
import { CoordinatesDisplayComponent } from './component/coordinates-display/coordinates-display.component';
import { VehicleDisplayComponent } from './component/vehicle-display/vehicle-display.component';
import { LastCoordinateDisplayComponent } from './component/last-coordinate-display/last-coordinate-display.component';
import { CanDiagnosisComponent } from './component/can-diagnosis/can-diagnosis.component';
import { CanDiagnosisItemComponent } from './component/can-diagnosis-item/can-diagnosis-item.component';
import { DiagnosisErrorDisplayComponent } from './component/diagnosis-error-display/diagnosis-error-display.component';
import { EmptyCanAnswerComponent } from './component/empty-can-answer/empty-can-answer.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    MaterializeModule
  ],
  exports: [
    DiagnosisComponent,
    VehicleSelectComponent,
    EquipmentDiagnosisComponent,
    GpsDiagnosisComponent,
    GprsDiagnosisComponent,
    CoordinateDiagnosisComponent,
    CoordinatesDisplayComponent,
    VehicleDisplayComponent,
    LastCoordinateDisplayComponent,
    CanDiagnosisComponent,
    CanDiagnosisItemComponent,
    DiagnosisErrorDisplayComponent,
    EmptyCanAnswerComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    DiagnosisService,
    VehicleService,
    DiagnosisWebSocketService
  ],
  declarations: [
    DiagnosisComponent,
    VehicleSelectComponent,
    EquipmentDiagnosisComponent,
    GpsDiagnosisComponent,
    GprsDiagnosisComponent,
    CoordinateDiagnosisComponent,
    CoordinatesDisplayComponent,
    VehicleDisplayComponent,
    LastCoordinateDisplayComponent,
    CanDiagnosisComponent,
    CanDiagnosisItemComponent,
    DiagnosisErrorDisplayComponent,
    EmptyCanAnswerComponent
  ]
})
export class DiagnosisModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/diagnosis.module.ts